<template>
    <div class="article-cookies">
        <p>
            This website uses cookies. We use video cookies to embed videos, analytical cookies to improve our website,
            and necessary cookies to enable core functionality. To find out how we use your personal data please consult
            our
            <nuxt-link to="/privacy">privacy policy</nuxt-link>.
        </p>
        <div v-if="!cookies.asked">
            <p>Your choice regarding cookies on this site:</p>
            <div class="flex flex-row space-x-3 pt-1">
                <!-- TODO - add icons to cookie buttons -->
                <button-primary buttonText="Accept Defaults" :buttonClick="acceptDefaultCookies"></button-primary>
                <button-primary
                    buttonColor="bg-zinc-100 text-zinc-900 hover:bg-zinc-50"
                    buttonText="Custom Settings"
                    :buttonClick="customiseCookieSettings"
                ></button-primary>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'ArticleCookies',
    computed: {
        ...mapState(useStoreCookies, {
            cookies: 'cookies',
        }),
    },
    methods: {
        ...mapActions(useStoreCookies, {
            acceptDefaultCookies: 'acceptDefaultCookies',
            customiseCookieSettings: 'customiseCookieSettings',
        }),
    },
};
</script>
